const Price = {
  // pdf价格
  "--theme-pdf-price-tag-bg": "#4C3626",
  "--theme-pdf-price-tag-bg-hover": "#4C3626",
  "--theme-pdf-price-tag-color": "#fff",
  "--theme-pdf-price-tag-color-hover": "#fff",

  "--theme-pdf-price-li-color": "#111112",
  "--theme-pdf-price-li-color-hover": "#111112",

  "--theme-pdf-price-tips-color": "#7D7D7F",
  "--theme-pdf-price-tips-color-hover": "#7D7D7F",
  "--theme-pdf-price-tips-bg": "#fff",
  "--theme-pdf-price-tips-bg-hover": "#fff",

  "--theme-pdf-price-color": "#FF612F",
  "--theme-pdf-price-color-hover": "#FF612F",

  "--theme-pdf-price-inner-bg": "#fff",
  "--theme-pdf-price-inner-bg-hover": "#fff",

  "--theme-pdf-price-btn": "#FF612F",
  "--theme-pdf-price-btn-hover": "#FF612F",

  "--theme-pdf-price-btn-color": "#111112",
  "--theme-pdf-price-btn-color-hover": "#111112",
}

const Questions = {
  // PDF
  // PDF quetions
  "--theme-pdf-questions-title-color": "#FF612F",
  "--theme-pdf-quesions-bg": "#4C3626",
  "--theme-pdf-quesions-inner-bg": "#4C3626",

  "--theme-pdf-quesions-item-bg": "#4C3626",
  "--theme-pdf-quesions-item-title-color": "#fff",
  "--theme-pdf-quesions-item-title-color-hover": "#fff",

  "--theme-pdf-question-icon-filter": "brightness(100)",

  "--theme-pdf-quesions-item-des-color": "#7D7D7F",
}


const Steps = {
  "--theme-pdf-step-bg": "#F2F4F3",
  "--theme-pdf-step-subtitle-color": "#111112",
  "--theme-pdf-step-inner-bg": "#fff"
}

const Explain = {
  "--theme-pdf-explain-inner-bg": "white",
}


const Comment = {
  "--theme-pdf-comment-item-bg": "#F2F4F3",
  "--theme-pdf-comment-city-color": "#7D7D7F",
  "--theme-pdf-comment-name-color": "#111112",
  "--theme-pdf-comment-subtitle-color": "#111112",

  "--theme-pdf-comment-item-bg-hover": "#4C3626",
  "--theme-pdf-comment-city-color-hover": "#FFF",
  "--theme-pdf-comment-name-color-hover": "#FFF",
  "--theme-pdf-comment-subtitle-color-hover": "#FFF",
}

export const coustomPDFblackCoffeeTheme = {
  //主题背景颜色
  "--theme-primary": "#4C3626",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#fff",
  // 登录按钮 字体颜色
  "--theme-primary-login-btn-suffix": "#fff",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#FF612F",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Price,
  ...Questions,
  ...Steps,
  ...Explain,
  ...Comment
}